// SocialShareButtons.js
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";

import styles from "@/components/social/SocialShareButtons.module.css";

const SocialShareButtons = ({ url, title, image, description, size = 32 }) => {
  const source = "https://clearwatt.co.uk";
  return (
    <div className={styles.socialButtons}>
      <FacebookShareButton url={url} quote={title}>
        <FacebookIcon round size={size} />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={title} image={image}>
        <TwitterIcon round size={size} />
      </TwitterShareButton>

      <LinkedinShareButton
        url={url}
        title={title}
        summary={description}
        source={url}>
        <LinkedinIcon round size={size} />
      </LinkedinShareButton>

      <WhatsappShareButton url={url} title={title}>
        <WhatsappIcon round size={size} />
      </WhatsappShareButton>
    </div>
  );
};

export default SocialShareButtons;
